import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';

import { ResponsiveText } from '../DataCard.style';

type NetworkStatusProps = {
  enableMapViewHideOption: boolean;
  sectionTypeDerived?: string;
  providerId?: string;
  cssProps: any;
  isGroupedLocationDrawer?: boolean;
  expandedProviderListView?: boolean;
  networkStatus: string;
  color: string;
  planList?: string[];
  isGEHAV2?: boolean;
};

export const NetWorkStatus = ({
  sectionTypeDerived,
  providerId,
  isGroupedLocationDrawer,
  expandedProviderListView,
  networkStatus,
  color,
  enableMapViewHideOption,
  cssProps,
  isGEHAV2,
}: NetworkStatusProps) => (
  <Flex
    css={{
      display: 'flex',
      alignItems: 'center',
      gap: '2px',
      flexWrap: expandedProviderListView ? 'wrap' : 'nowrap',
      paddingTop:
        expandedProviderListView && sectionTypeDerived === 'Facility'
          ? '20px'
          : '0px',
    }}
  >
    <IconSymbol
      color={color}
      css={{
        aspectRatio: '1/1',
      }}
      data-auto-testid={`data-card-check-circle-icon-${sectionTypeDerived}-${providerId}`}
      data-testid={`data-card-check-circle-icon-${sectionTypeDerived}-${providerId}`}
      icon="check_circle"
      size={isGroupedLocationDrawer || !expandedProviderListView ? 16 : 20}
      variant="outlined"
    />
    <ResponsiveText
      color={isGEHAV2 ? '$core.color.brand.100' : ''}
      cssProps={cssProps}
      data-auto-testid={`data-card-network-${sectionTypeDerived}-${providerId}`}
      data-testid={`data-card-network-${sectionTypeDerived}-${providerId}`}
      fontWeight={enableMapViewHideOption ? 'regular' : 'medium'}
    >
      {networkStatus}
    </ResponsiveText>
  </Flex>
);
